import {v4 as uuid } from 'uuid';
export default function selecteDeselectSchedule (scheduleId) {
    if (this.selectedSchedules[scheduleId]) {
        delete this.selectedSchedules[scheduleId];
    } else {
        this.selectedSchedules[scheduleId] = true;
    }
    this.observed.selectedSchedules = uuid();
}

export function getSelectedSchedules () {
    return Object.keys(this.selectedSchedules);
}

/* on Auto Subscribe all schedules are selected */
export function selectAllSchedules () {
    if (this.schedules) {
        this.selectedSchedules = {};
        this.schedules.forEach(schedule => {
            this.selectedSchedules[schedule.id] = true;
        });
        this.observed.selectedSchedules = uuid();
    }
}